export default "__VITE_ASSET__D1$1MIMj__"